// This file is auto-generated by Velocious. Do not edit it manually — any changes
// will be overwritten the next time it is generated. Run `velocious generate:base-models --tenant projectReplica` to regenerate.
import DatabaseRecord from "velocious/build/src/database/record/index.js"

/**
 * Attributes accepted when creating or updating ReplicaMetadata records.
 * @typedef {object} ReplicaMetadataWriteAttributes
 * @property {string} [id] - Value for the id attribute.
 * @property {string} [key] - Value for the key attribute.
 * @property {string} [value] - Value for the value attribute.
 * @property {Date | string} [createdAt] - Value for the createdAt attribute.
 * @property {Date | string} [updatedAt] - Value for the updatedAt attribute.
 */

/** @augments {DatabaseRecord<ReplicaMetadataWriteAttributes>} */
export default class ReplicaMetadataBase extends DatabaseRecord {
  /** @returns {typeof import("../models/replica-metadata.js").default} */
  // @ts-ignore - override narrows return type for better IntelliSense in generated model bases
  getModelClass() { return /** @type {typeof import("../models/replica-metadata.js").default} */ (this.constructor) }

  /** @returns {string} */
  id() { return this.readAttribute("id") }

  /**
   * @param {string} newValue
   * @returns {void}
   */
  setId(newValue) { return this._setColumnAttribute("id", newValue) }

  /** @returns {boolean} */
  hasId() { return this._hasAttribute(this.id()) }

  /** @returns {string} */
  key() { return this.readAttribute("key") }

  /**
   * @param {string} newValue
   * @returns {void}
   */
  setKey(newValue) { return this._setColumnAttribute("key", newValue) }

  /** @returns {boolean} */
  hasKey() { return this._hasAttribute(this.key()) }

  /** @returns {string} */
  value() { return this.readAttribute("value") }

  /**
   * @param {string} newValue
   * @returns {void}
   */
  setValue(newValue) { return this._setColumnAttribute("value", newValue) }

  /** @returns {boolean} */
  hasValue() { return this._hasAttribute(this.value()) }

  /** @returns {Date} */
  createdAt() { return this.readAttribute("createdAt") }

  /**
   * @param {Date | string} newValue
   * @returns {void}
   */
  setCreatedAt(newValue) { return this._setColumnAttribute("createdAt", newValue) }

  /** @returns {boolean} */
  hasCreatedAt() { return this._hasAttribute(this.createdAt()) }

  /** @returns {Date} */
  updatedAt() { return this.readAttribute("updatedAt") }

  /**
   * @param {Date | string} newValue
   * @returns {void}
   */
  setUpdatedAt(newValue) { return this._setColumnAttribute("updatedAt", newValue) }

  /** @returns {boolean} */
  hasUpdatedAt() { return this._hasAttribute(this.updatedAt()) }
}
